import Constants from "expo-constants";

const DEFAULT_ORDER_IDENTIFIER_PREFIX = "D";

const ORDER_IDENTIFIER_PREFIXES: Record<string, string> = {
  production: "P",
  "dr-prod": "P",
  staging: "S",
  dev: "D",
  development: "D",
};

export const getOrderIdentifierPrefix = (
  envName: string | undefined = Constants.expoConfig?.extra?.envName,
): string =>
  (envName && ORDER_IDENTIFIER_PREFIXES[envName.toLowerCase()]) ||
  DEFAULT_ORDER_IDENTIFIER_PREFIX;
